import { z } from 'zod';

const comissaoSchema = z.object({
    guia: z.object({
        value: z.string(),
        label: z.string()
    }, { message: "Selecione o guia!" }),
    dataInicial: z.coerce.date(),
    dataFinal: z.coerce.date(),
    dataPagamento: z.coerce.date(),
    comissaoTour: z.coerce.number().min(0, { message: "Informe um valor válido" }),
    comissaoLojaTour: z.coerce.number().min(0, { message: "Informe um valor válido" }),
    comissaoLojaCentro: z.coerce.number().min(0, { message: "Informe um valor válido" }),
    pagamentoEfetivado: z.object({
        value: z.string(),
        label: z.string()
    }) 
});

export default comissaoSchema;